import { useNuxtApp } from "#app";
import { BaseService } from "../base/base.service";
import type { IModelResponse } from "../base/dto/base.dto";
import { RolesRepository } from "./roles.repository";
import { ModelRoleDetail, ModelRoles } from "./dto/roles.dto";
import { ModelPermission } from "./dto/permission.dto";

export class RolesService extends BaseService {
  private rolesRepository = new RolesRepository(this.api, this.configService);

  async getRoleList(params: any): Promise<IModelResponse<ModelRoles[]>> {
    const { $functions } = useNuxtApp();
    let dataResult: IModelResponse<ModelRoles[]> = {
      data: [],
    };
    try {
      const res = await this.rolesRepository.getRoleList(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        const dataList = (resData.data || []).map((e) => new ModelRoles(e));
        dataResult.data = dataList;
        dataResult.totalItems = resData.totalItems;
        console.log("getRoleList", resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, RolesService.name);
    }
    return dataResult;
  }

  async getPermissionList(params: any): Promise<IModelResponse<ModelPermission[]>> {
    const { $functions } = useNuxtApp();
    let dataResult: IModelResponse<ModelPermission[]> = {
      data: [],
    };
    try {
      const res = await this.rolesRepository.getPermissionList(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        const dataList = (resData.data || []).map((e) => new ModelPermission(e));
        dataResult.data = dataList;
        dataResult.totalItems = resData.totalItems;
        console.log("getPermissionList", resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, RolesService.name);
    }
    return dataResult;
  }

  async getRoleDetail(id: number | string): Promise<ModelRoleDetail> {
    const { $functions } = useNuxtApp();
    let dataResult: ModelRoleDetail = new ModelRoleDetail();
    try {
      const res = await this.rolesRepository.getRoleDetail(id);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelRoleDetail(resData.data);
        console.log("getRoleDetail", resData, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, RolesService.name);
    }
    return dataResult;
  }

  async createRole(params: any): Promise<IModelResponse<any>> {
    const { $functions } = useNuxtApp();
    let dataResult: IModelResponse<any> = {
      data: null,
    };
    try {
      const res = await this.rolesRepository.createRole(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult.data = resData;
        console.log("createRole", resData, dataResult);
      }
    } catch (err: any) {
      // $functions.notify.error({
      //   text: err.message,
      //   isError: true,
      // });
      console.log(err, RolesService.name);
    }
    return dataResult;
  }

  async updateRole(params: any): Promise<IModelResponse<any>> {
    const { $functions } = useNuxtApp();
    let dataResult: IModelResponse<any> = {
      data: null,
    };
    try {
      const res = await this.rolesRepository.updateRole(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult.data = resData;
        console.log("updateRole", resData, dataResult);
      }
    } catch (err: any) {
      // $functions.notify.error({
      //   text: err.message,
      //   isError: true,
      // });
      console.log(err, RolesService.name);
    }
    return dataResult;
  }
}